import {getContext} from 'svelte';
import type {Logger, DateFormatter, Injector, LocalizeFunction} from './types';
import {DATE_FORMATTER_KEY, INJECTOR_KEY, LOCALIZE_KEY, LOGGER_KEY} from './utils';

export function getLogger(): Logger | undefined {
    return getContext(LOGGER_KEY);
}

export function getLocalization(): LocalizeFunction {
    return getContext(LOCALIZE_KEY);
}

export function getDateFormatter(): DateFormatter {
    return getContext(DATE_FORMATTER_KEY);
}

export function getInjector(): Injector {
    return getContext(INJECTOR_KEY);
}